import React, { useMemo, useRef, useEffect, useState } from 'react';

import { parseDateDesktop, parseDateDay, parseDateNumber, parseEntities, today } from '../../utils/helpers';

const FilterBarMobile = ({
  filteredCount,
  activeFilterDate,
  activeTimestamp,
  activeCinema,
  activeTags,
  sortingDecision,
  availableDates,
  availableCinema,
  availableTags,
  currentConfig,
  showFilters,
  handleToggle,
  handleFilter,
}) => {
  const ref = useRef(),
    [isSticky, setIsSticky] = useState(false),
    [showModalFilterMobile, setShowModalFilterMobile] = useState(false),
    [rootMargin, setRootMargin] = useState(0);

  const toggleMobileFilter = () => {
    setShowModalFilterMobile(!showModalFilterMobile);
  };

  const displayAmountActiveFilters = () => {
    let counter = 0;
    counter = counter + activeCinema.length + activeTags.length;
    if (counter <= 0) return '';
    return ` (${counter})`;
  };

  const calcRootMargin = () => {
    setRootMargin(
      window
        .getComputedStyle(document.body)
        .getPropertyValue('--header-height')
        .replace(/[^\d.]/g, '') *
        parseFloat(getComputedStyle(document.documentElement).fontSize) +
        2
    );
  };

  useEffect(() => {
    calcRootMargin();
    window.addEventListener('resize', calcRootMargin);

    const cachedRef = ref.current,
      observer = new IntersectionObserver(
        ([e]) => {
          setIsSticky(e.intersectionRatio < 1);
        },
        {
          threshold: [1],
          rootMargin: `-${rootMargin}px 0px 0px 0px`, // alternativly, use this and set `top:0` in the CSS
        }
      );
    observer.observe(cachedRef);

    // unmount
    return function () {
      observer.unobserve(cachedRef);
      window.removeEventListener('resize', calcRootMargin);
    };
  }, [rootMargin]);

  return (
    <>
      {showFilters.includes('date') && currentConfig.sorting_option_mobile_nonemodal && currentConfig.has_sorting_option && activeFilterDate && (
        <div className="filter-modal__option custom-toggle__non-model flow show@until-tablet-l">
          <div className="custom-toggle">
            <label className="custom-toggle__toggle  sort-switch-options">
              <input
                // toggle direction random choice here: if popularity is chosen toggle is "on" (knob to the right) and otherwise time is chosen so toggle is "off"
                checked={sortingDecision === 'times'}
                onChange={handleToggle}
                className="custom-toggle__input"
                id="sort-switch"
                type="checkbox"
              />
              <span className="custom-toggle__slider  sort-switch-slider"></span>
              <span
                className="custom-toggle__labels sort-switch-labels"
                data-onsmall={customData.i18n.agenda_sort_option_movies}
                data-on={customData.i18n.agenda_sort_option_movies}
                data-off={customData.i18n.agenda_sort_option_times}
              ></span>
            </label>
          </div>
        </div>
      )}
      <div ref={ref} className={`filter-bar filter-bar__phone show@until-tablet-l ${isSticky ? ' isSticky' : ''}`}>
        <button onClick={toggleMobileFilter} className="filter-trigger">
          {activeFilterDate ? parseDateDesktop(activeTimestamp) : customData.i18n.agenda_date_all}
          <span className="filter-trigger__label">
            {customData.i18n.agenda_filter_button_mobile}
            {displayAmountActiveFilters()}
          </span>
        </button>

        <div className={`filter-modal  is-leiden ${!showModalFilterMobile ? 'is-hidden-important' : ''}`}>
          <div className="filter-modal__header">
            <div className="filter-modal__title  fw-900  uc">{customData.i18n.agenda_filter_button_mobile}</div>
            <button className="modal__close" onClick={toggleMobileFilter} aria-label="close modal">
              <svg className="svg-inline" version="1.1" viewBox="0 0 14 14" aria-hidden="true" focusable="false">
                <path d="M7 7.378l3.363 3.363a.496.496 0 00.703-.004c.19-.19.197-.51.004-.703L7.707 6.67l3.363-3.363a.496.496 0 00-.004-.703.502.502 0 00-.703-.004L7 5.964 3.637 2.6a.496.496 0 00-.703.004.502.502 0 00-.004.703L6.293 6.67 2.93 10.034a.496.496 0 00.004.703c.19.19.51.197.703.004L7 7.378z" />
              </svg>
            </button>
          </div>
          <div className="filter-modal__content flow">
            {showFilters.includes('date') && (
              <div className="filter-modal__option filter-modal__option--date flow">
                <div className="filter-modal__title">{activeFilterDate ? parseDateDesktop(activeTimestamp) : customData.i18n.agenda_date_all}</div>
                <div className="filter-modal__viewport">
                  <ul className="listbox listbox__mobile" role="listbox" aria-labelledby="date_label" aria-activedescendant="date_000" tabIndex="-1">
                    <li
                      onClick={() => handleFilter('filterDate', 'all')}
                      role="option"
                      className={activeFilterDate === false ? 'has-focus' : ''}
                      id="date_000"
                      aria-selected={activeFilterDate === false ? 'true' : 'false'}
                      data-value="all"
                      key="all"
                    >
                      <span className="days">{customData.i18n.agenda_date_all}</span>
                    </li>

                    {availableDates.map(
                      (date, index) =>
                        date >= today && (
                          <li
                            onClick={() => handleFilter('filterDate', date)}
                            role="option"
                            className={date === activeTimestamp ? activeFilterDate && 'has-focus' : ''}
                            id="date_000"
                            aria-selected={date === activeTimestamp ? activeFilterDate && 'true' : 'false'}
                            data-value={date}
                            key={index}
                          >
                            {parseDateDesktop(date) === 'Vandaag' || parseDateDesktop(date) === 'Morgen' || parseDateDesktop(date) === 'Today' || parseDateDesktop(date) === 'Tomorrow' ? (
                              <span className="days">{parseDateDesktop(date)}</span>
                            ) : (
                              <>
                                <span className={`day${parseDateNumber(date) == '' ? 's' : ''}`}>{parseDateDay(date)}</span>
                                {parseDateNumber(date) !== '' && <span className="date">{parseDateNumber(date)}</span>}
                              </>
                            )}
                          </li>
                        )
                    )}
                  </ul>
                </div>
              </div>
            )}

            {/* functionality for sorting by popularity or times */}
            {showFilters.includes('date') && currentConfig.has_sorting_option && activeFilterDate && (
              <div className="filter-modal__option flow">
                <div className="custom-toggle">
                  <label className="custom-toggle__toggle  sort-switch-options">
                    <input
                      // toggle direction random choice here: if popularity is chosen toggle is "on" (knob to the right) and otherwise time is chosen so toggle is "off"
                      checked={sortingDecision === 'times'}
                      onChange={handleToggle}
                      className="custom-toggle__input"
                      id="sort-switch"
                      type="checkbox"
                    />
                    <span className="custom-toggle__slider  sort-switch-slider"></span>
                    <span
                      className="custom-toggle__labels sort-switch-labels"
                      data-onsmall={customData.i18n.agenda_sort_option_movies}
                      data-on={customData.i18n.agenda_sort_option_movies}
                      data-off={customData.i18n.agenda_sort_option_times}
                    ></span>
                  </label>
                </div>
              </div>
            )}

            {showFilters.includes('cinema') && (
              <div className="filter-modal__option flow">
                <div className="fw-900 uc">
                  {customData.i18n.agenda_filter_choose} {customData.i18n.agenda_cinema_name}
                </div>
                <ul
                  className="listbox listbox--multi listbox__mobile listbox--multi-cinema"
                  role="listbox"
                  aria-labelledby="bioscoop_label"
                  aria-multiselectable="true"
                  aria-activedescendant=""
                  tabIndex="-1"
                >
                  {availableCinema.map((cinemaOption, index) => (
                    <li
                      onClick={() => handleFilter('filterCinema', cinemaOption)}
                      role="option"
                      id="date_000"
                      aria-selected={activeCinema.includes(cinemaOption) ? 'true' : 'false'}
                      data-value={cinemaOption}
                      key={index}
                      data-cinema_id={cinemaOption}
                    >
                      {cinemaOption}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {showFilters.includes('tags') && (
              <div className="filter-modal__option flow">
                <div className="fw-900 uc">
                  {customData.i18n.agenda_filter_choose} {customData.i18n.agenda_tag_filter_name}
                </div>
                <ul className="listbox listbox--multi listbox__mobile" role="listbox" aria-labelledby="label_label" aria-multiselectable="true" aria-activedescendant="" tabIndex="-1">
                  {availableTags.map((tag, index) =>
                    currentConfig.tags_hide_from_dropdown.includes(tag) ? (
                      ''
                    ) : (
                      <li onClick={() => handleFilter('filterTags', tag, false)} role="option" id="date_000" aria-selected={activeTags.includes(tag) ? 'true' : 'false'} data-value={tag} key={index}>
                        {parseEntities(tag)}
                      </li>
                    )
                  )}
                </ul>
              </div>
            )}
          </div>

          <div className="filter-modal__footer">
            <button className="filter-modal__reset" onClick={() => handleFilter('resetFilters', null)}>
              {customData.i18n.agenda_delete_filters}
            </button>
            <button className={`btn btn--submit btn--secundary ${currentConfig.name === 'Kinorotterdam' ? 'btn--medium' : ''}`} onClick={toggleMobileFilter}>
              {customData.i18n.agenda_results_mobile_show} {filteredCount} {customData.i18n.agenda_results_mobile_movie}
              {filteredCount === 1 ? '' : 's'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterBarMobile;
